/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: zxf
 * @LastEditTime: 2022-08-08 17:25:05
 * @Description: 业务通用路由
 */
/* =============================================
   业务功能路由配置文件引入start
  *
  *
*/
// 签到信息管理
import qdxxRoutes from '@/features/common/qdxx/qdxx.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [
  qdxxRoutes
];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const commonRoutes = {
  path: 'common',
  name: 'common',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default commonRoutes;
